/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Online_Price_Clear_ConfirmInputs */

const vi_online_price_clear_confirm = /** @type {(inputs: Online_Price_Clear_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ giá Online của ${i?.sku}? Website sẽ bán theo giá ERP + VAT.`)
};

/**

* @param {Online_Price_Clear_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_clear_confirm = /** @type {((inputs: Online_Price_Clear_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Clear_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_clear_confirm(inputs)
});